import { render, staticRenderFns } from "./UserShortInfoBox.vue?vue&type=template&id=b76ca9ac&scoped=true&"
import script from "./UserShortInfoBox.vue?vue&type=script&lang=babel&"
export * from "./UserShortInfoBox.vue?vue&type=script&lang=babel&"
import style0 from "./UserShortInfoBox.vue?vue&type=style&index=0&id=b76ca9ac&prod&lang=scss&scoped=true&"
import style1 from "./UserShortInfoBox.vue?vue&type=style&index=1&id=b76ca9ac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b76ca9ac",
  null
  
)

export default component.exports